"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
var styleUtilities_1 = require("../../../util/styleUtilities");
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var width = _a.width;
            return ({
                borderRadius: 4,
                boxShadow: theme_1.default.shadows.weak,
                minWidth: 148,
                height: 48,
                padding: 12,
                width: width !== null && width !== void 0 ? width : 'max-content',
                display: 'grid',
                gridTemplateColumns: 'min-content auto 24px',
                alignItems: 'center',
                columnGap: 4,
                cursor: 'pointer',
                backgroundColor: 'white',
                userSelect: 'none',
            });
        },
        rootWithHover: {
            '&:hover': {
                border: theme_1.default.borders.highlight,
                padding: '11px !important',
            },
        },
        rootNoIcon: {
            gridTemplateColumns: 'auto 24px !important',
        },
        selected: {
            border: theme_1.default.borders.highlight,
            backgroundColor: "".concat((0, styleUtilities_1.withOpacity)(theme_1.default.colors.primaryLight, 0.5), " !important"),
            padding: '11px !important',
        },
        cursorDefault: {
            cursor: 'default',
        },
        disabled: {
            opacity: 0.5,
        },
    });
});
